import { 
  Facebook, 
  Instagram, 
  Linkedin, 
  Youtube,
  Mail,
  Phone,
  MapPin
} from 'lucide-react';

const footerLinks = {
  produto: [
    { label: 'PDV', href: '#modulos' },
    { label: 'KDS Cozinha', href: '#modulos' },
    { label: 'Dashboard', href: '#modulos' },
    { label: 'Delivery', href: '#modulos' },
    { label: 'Estoque', href: '#modulos' },
    { label: 'Fidelidade', href: '#modulos' }
  ],
  recursos: [
    { label: 'Blog', href: '#contato' },
    { label: 'Central de Ajuda', href: 'https://wa.me/5511934664558?text=Olá! Preciso de ajuda.', external: true },
    { label: 'API Docs', href: '#contato' },
    { label: 'Status do Sistema', href: '#contato' },
    { label: 'Atualizações', href: '#como-funciona' }
  ],
  empresa: [
    { label: 'Sobre nós', href: '#depoimentos' },
    { label: 'Carreiras', href: '#contato' },
    { label: 'Parceiros', href: '#contato' },
    { label: 'Imprensa', href: '#contato' },
    { label: 'Contato', href: '#contato' }
  ],
  legal: [
    { label: 'Termos de Uso', href: '#contato' },
    { label: 'Privacidade', href: '#contato' },
    { label: 'Cookies', href: '#contato' },
    { label: 'LGPD', href: '#contato' }
  ]
};

const socialLinks = [
  { icon: Instagram, href: 'https://instagram.com/avak.co', label: 'Instagram' },
  { icon: Facebook, href: 'https://facebook.com/avak.co', label: 'Facebook' },
  { icon: Linkedin, href: 'https://linkedin.com/company/avak', label: 'LinkedIn' },
  { icon: Youtube, href: 'https://youtube.com/@avak', label: 'YouTube' }
];

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a href="#" className="flex items-center gap-2 mb-6">
              <img 
                src="/team/avak-logo.png" 
                alt="AVAK" 
                className="h-10 w-auto"
              />
            </a>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Plataforma de gestão para restaurantes com Inteligência Artificial. 
              PDV, cozinha, estoque e análise de clientes - tudo automatizado.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <a href="mailto:contato@avak.com.br" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
                contato@avak.com.br
              </a>
              <a href="tel:+5511934664558" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <Phone className="w-5 h-5" />
                (11) 93466-4558
              </a>
              <div className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-5 h-5 mt-0.5" />
                <span>São Paulo, SP - Brasil</span>
              </div>
            </div>
          </div>

          {/* Produto */}
          <div>
            <h4 className="font-bold text-lg mb-4">Produto</h4>
            <ul className="space-y-3">
              {footerLinks.produto.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Recursos */}
          <div>
            <h4 className="font-bold text-lg mb-4">Recursos</h4>
            <ul className="space-y-3">
              {footerLinks.recursos.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-bold text-lg mb-4">Empresa</h4>
            <ul className="space-y-3">
              {footerLinks.empresa.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-lg mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-slate-400 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-custom py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} AVAK. Todos os direitos reservados.
          </p>
          
          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                aria-label={social.label}
                className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all"
              >
                <social.icon className="w-5 h-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
